import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-power-select/dist/react-power-select.css';
import {PowerSelect} from 'react-power-select';
import CurrencyInput from 'react-currency-input';

const CustomOptionComponent = ({ option }) => (
<div>
  <span>{option.first_name+' '+option.last_name} </span>
</div>
);

export default class PortalJobUserTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: props.isLoading || true,
      job: props.data || null,
      jobId: props.jobId || null,
      selectOptions: [],
      user_task_instruction_detail: props.user_task_instruction_detail || null,
      selectedOption: props.selectedOption || null, 
      hasAssignedDriver:props.hasAssignedDriver || false,
      isQuickDriverPlannScreenUserTask:props.isQuickDriverPlannScreenUserTask || false,
      isZonePage:props.isZonePage || false,
      isLoaderActive:false
    };
    this.handlePickupDateCalendarChange = this.
    handlePickupDateCalendarChange.bind(this);      
    this.handleDropoffDateCalendarChange = this.
    handleDropoffDateCalendarChange.bind(this);
    this.handleInfo = this.handleInfo.bind(this);
    this.handleChangeRoles = this.handleChangeRoles.bind(this);
    //this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
  }
  componentWillReceiveProps(nextProps) {
      this.setState({
        selectedOption: nextProps.selectedOption,
        jobId: nextProps.jobId,
        job: nextProps.data,
        isLoading: nextProps.isLoading,
        isQuickDriverPlannScreenUserTask: nextProps.isQuickDriverPlannScreenUserTask || false,
      });
  }
  postData(url = ``, data = {}) {
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: JSON.stringify(data),
    }).
    then(
      response => response //=> response.json()
    );
  }
  handleChange = ({ option }) => {
    this.setState({
      selectedOption: option
    })
  }

  handleInfo(event) {
    this.setState({user_task_instruction_detail: event.target.value});
  }

  handleChangeRoles() {
    let selectedCompanyData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      customer_id: this.state.customer_id,
      selected_company: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=selected_company]'
      ).value
    };
    this.postData('/api/v1/portal/jobs/fetch-user-names', selectedCompanyData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          response.json().then(responseText => {
            this.setState({selectOptions: responseText});
            $("#user_task_list"+this.state.job.id).val(0).change();
          });          
        }
      }).
      catch(error => {
          $('#job-scheduler-modal').modal('modal');
        }
      );
  }
  handleJobUserTaskSave() {
    this.setState({isLoaderActive:true});
    let selectedCompanyData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      selected_company: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=selected_company]'
      ).value,
      selected_user_id: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=selected_company_user]'
      ).value,
      user_task_special_instruction: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=user_task_special_instruction]'
      ).value,
      pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=pickup_preposition]'
      ).value,
      pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_day]'
      ).value,
      pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_month]'
      ).value,
      pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_year]'
      ).value,
      pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_time]'
      ).value,

      dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_preposition]'
      ).value,
      dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_day]'
      ).value,
      dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_month]'
      ).value,
      dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_year]'
      ).value,
      dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_time]'
      ).value
    };

      this.postData('/api/v1/portal/jobs/save-job-user-task-btn', selectedCompanyData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          $('#infomodallabel').html('User task');
          $('#infomodal .modal-body').html('User task saved');
          $('#infomodal').modal();
          this.props.showJobUserTaskScheduler();
          this.props.isQuickDriverPlannScreenClickUserTasks();
          this.setState({isLoaderActive:false});
        }
      }).
      catch(error => {
          $('#job-scheduler-modal').modal('modal');
        }
      );
  }
  handleDropoffDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_year]'
    ).value = date.getFullYear();
    this.setState({
      dropoff_date: date
    });
  }
  handlePickupDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_year]'
    ).value = date.getFullYear();
    this.setState({pickup_date: date});
  }
  handleJobUserTaskUpdate() {
    this.setState({isLoaderActive:true});
    let selectedCompanyData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      user_instruction_id: this.state.job.user_instruction_id,
      selected_company: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=selected_company]'
      ).value,
      selected_user_id: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=selected_company_user]'
      ).value,
      user_task_special_instruction: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=user_task_special_instruction]'
      ).value,
      pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=pickup_preposition]'
      ).value,
      pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_day]'
      ).value,
      pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_month]'
      ).value,
      pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_year]'
      ).value,
      pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_time]'
      ).value,

      dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_preposition]'
      ).value,
      dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_day]'
      ).value,
      dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_month]'
      ).value,
      dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_year]'
      ).value,
      dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_time]'
      ).value
    };
    console.log(selectedCompanyData);
      this.postData('/api/v1/portal/jobs/update-job-user-task-btn', selectedCompanyData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          $('#infomodallabel').html('User task');
          $('#infomodal .modal-body').html('User task updated');
          $('#infomodal').modal();
          this.props.showJobUserTaskScheduler();
          this.props.isQuickDriverPlannScreenClickUserTasks();
          this.setState({isLoaderActive:false});
        }
      }).
      catch(error => {
          $('#job-scheduler-modal').modal('modal');
        }
      );
  }
  render() {
  let Users = [];
    Users.push(<option value='0'>Select User</option>);
    this.state.selectOptions.forEach(function(i) {
        Users.push(<option value={i.id}>{i.full_name}</option>);
      });
    return (<div>
      {(this.state.job && this.state.job.id ?
        <div className="job-scheduler-modal">
          <div className="job-scheduler-modal-header">
          </div>
          <div className="job-scheduler-modal-body">
          <form
            id={'job-scheduler-for-job-'+this.state.job.id}
            className="text-left schedule_job_form">
            <fieldset>
              <h1 className="text-right">Job #{this.state.jobId}</h1>
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h3>User Company : </h3>
                </div>
                <div className="col-md-8 drivers-dropdown" style={{'marginTop': '14px'}}>                  
                  <select name="selected_company" id={'user_company_list'+this.state.job.id} required
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.user_company_id)
                ? this.state.job.user_instruction_detail.user_company_id : ''
              }
                          className="form-control user_company_list"
                           onChange={this.handleChangeRoles} required>
                    <option value="0">Select Company</option>
                    <option value="1">ACV</option>
                    <option value="2">SCCD</option>
                    <option value="3">CND</option>
                    <option value="4">BVL</option>
                    <option value="5">G4</option>
                  </select>
                </div>
              </div>
              <br /><br />
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h3>User list based on selected roles: </h3>
                </div>
                <div className="col-md-8 drivers-dropdown" style={{'marginTop': '14px'}}>
                      <select name="selected_company_user" required className="form-control user_company_list" required id={'user_task_list'+this.state.job.id}>
                           {Users}
                    </select>
                </div>
              </div>
              <br /><br />
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h3>Task start date: <DatePicker
                  customInput={
                    <a className="btn btn-default">
                      <i className="far fa-calendar-alt"></i>
                    </a>
                  }
                  selected={this.state.pickup_date}
                  onChange={this.handlePickupDateCalendarChange}/></h3>
                </div>
                <div className="col-md-8 drivers-dropdown" style={{'marginTop': '14px'}}>
                  <div className="input-group">
                  <select name="pickup_preposition" required
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.pickup_preposition)
                ? this.state.job.user_instruction_detail.pickup_preposition : ''
              }
                          className="timedropdown form-control"
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="pickup_day" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.pickup_day)
                ? this.state.job.user_instruction_detail.pickup_day : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="pickup_month" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.pickup_month)
                ? this.state.job.user_instruction_detail.pickup_month : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;

                  <select name="pickup_year" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.pickup_year)
                ? this.state.job.user_instruction_detail.pickup_year : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                  </select>
                  &nbsp;@&nbsp;

                  <select name="pickup_time" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.pickup_time)
                ? this.state.job.user_instruction_detail.pickup_time : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="1230">12:30 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0630">6:30 AM</option>
                  </select>
                </div>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h3>Task end date: <DatePicker
                  customInput={
                    <a className="btn btn-default">
                      <i className="far fa-calendar-alt"></i>
                    </a>
                  }
                  selected={this.state.dropoff_date}
                  onChange={this.handleDropoffDateCalendarChange}/></h3>
                </div>
                <div className="col-md-8 drivers-dropdown" style={{'marginTop': '14px'}}>
                <div className="input-group">
                  <select name="dropoff_preposition" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.dropoff_preposition)
                ? this.state.job.user_instruction_detail.dropoff_preposition : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="dropoff_day" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.dropoff_day)
                ? this.state.job.user_instruction_detail.dropoff_day : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_month" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.dropoff_month)
                ? this.state.job.user_instruction_detail.dropoff_month : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_year" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.dropoff_year)
                ? this.state.job.user_instruction_detail.dropoff_year : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                  </select>
                  &nbsp;@&nbsp;
                  <select name="dropoff_time" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.user_instruction_detail &&
                this.state.job.user_instruction_detail.dropoff_time)
                ? this.state.job.user_instruction_detail.dropoff_time : ''
              }
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="1230">12:30 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0630">6:30 AM</option>
                  </select>
                </div>
                </div>
              </div>
              <br /><br />
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h3>Special Instruction: </h3>
                </div>
                <div className="col-md-8 drivers-dropdown" style={{'marginTop': '14px'}}>
                  <textarea className="form-control form-control-lg"
                    name="user_task_special_instruction"
                    id="user_task_special_instruction" rows='6' value={(this.state.user_task_instruction_detail) ? this.state.user_task_instruction_detail : ''} onChange={this.handleInfo}>
                  </textarea>
                </div>
              </div>
              <div className="scheduler-submit-buttons-container">
                {(this.state.job.user_instruction_id === null) ?
                  <button
                    className="btn btn-lg btn-primary"
                    onClick={() =>
                      this.handleJobUserTaskSave()
                    }
                    disabled={(this.state.isLoaderActive) ? true:false}
                    type="button">
                    <i className="fa fa-mobile">
                    </i>&nbsp;
                    Save UserTask 
                  </button>
                : 
                <button
                    className="btn btn-lg btn-primary"
                    onClick={() =>
                      this.handleJobUserTaskUpdate()
                    }
                    disabled={(this.state.isLoaderActive) ? true:false}
                    type="button">
                    <i className="fa fa-mobile">
                    </i>&nbsp;
                    Update UserTask 
                  </button>
                }
              </div>
              <br/><br/><br/>
            </fieldset>
          </form>
        </div>
      </div> : null)}
    </div>
    );
  }
}
